import React from 'react'
import { TextField, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    songPartLength: {
        width: "4ch",
      },
}))

const SongPartLength = (props) => {
    const classes = useStyles();

    return (
        <TextField
                className={classes.songPartLength}
                id={props.songPart.id}
                variant="standard"
                defaultValue={props.songPart.length}
                onChange={(e) => props.handleValueChange(props.songPart.id, e)}
              />
    )
}

export default SongPartLength
